/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionItem } from './SubscriptionItem';
import {
    SubscriptionItemFromJSON,
    SubscriptionItemFromJSONTyped,
    SubscriptionItemToJSON,
    SubscriptionItemToJSONTyped,
} from './SubscriptionItem';
import type { StripeSubscriptionStatusEnum } from './StripeSubscriptionStatusEnum';
import {
    StripeSubscriptionStatusEnumFromJSON,
    StripeSubscriptionStatusEnumFromJSONTyped,
    StripeSubscriptionStatusEnumToJSON,
    StripeSubscriptionStatusEnumToJSONTyped,
} from './StripeSubscriptionStatusEnum';

/**
 * A serializer for Subscriptions which uses the SubscriptionWrapper object under the hood
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     *
     * @type {string}
     * @memberof Subscription
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof Subscription
     */
    displayName: string;
    /**
     * Date when the subscription was first created. The date might differ from the created date due to backdating.
     * @type {Date}
     * @memberof Subscription
     */
    startDate?: Date | null;
    /**
     *
     * @type {string}
     * @memberof Subscription
     */
    billingInterval: string;
    /**
     * Start of the current period for which the subscription has been invoiced.
     * @type {Date}
     * @memberof Subscription
     */
    currentPeriodStart: Date;
    /**
     * End of the current period for which the subscription has been invoiced. At the end of this period, a new invoice will be created.
     * @type {Date}
     * @memberof Subscription
     */
    currentPeriodEnd: Date;
    /**
     * If the subscription has been canceled with the ``at_period_end`` flag set to true, ``cancel_at_period_end`` on the subscription will be true. You can use this attribute to determine whether a subscription that has a status of active is scheduled to be canceled at the end of the current period.
     * @type {boolean}
     * @memberof Subscription
     */
    cancelAtPeriodEnd?: boolean;
    /**
     * The status of this subscription.
     *
     * * `active` - Active
     * * `canceled` - Canceled
     * * `incomplete` - Incomplete
     * * `incomplete_expired` - Incomplete Expired
     * * `past_due` - Past due
     * * `trialing` - Trialing
     * * `unpaid` - Unpaid
     * @type {StripeSubscriptionStatusEnum}
     * @memberof Subscription
     */
    status: StripeSubscriptionStatusEnum;
    /**
     * The quantity applied to this subscription. This value will be `null` for multi-plan subscriptions
     * @type {number}
     * @memberof Subscription
     */
    quantity?: number | null;
    /**
     *
     * @type {Array<SubscriptionItem>}
     * @memberof Subscription
     */
    items: Array<SubscriptionItem>;
    /**
     *
     * @type {boolean}
     * @memberof Subscription
     */
    isMetered: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Subscription
     */
    isTrialing: boolean;
    /**
     *
     * @type {Date}
     * @memberof Subscription
     */
    trialEnd: Date | null;
    /**
     *
     * @type {string}
     * @memberof Subscription
     */
    readonly currency: string | null;
}



/**
 * Check if a given object implements the Subscription interface.
 */
export function instanceOfSubscription(value: object): value is Subscription {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('billingInterval' in value) || value['billingInterval'] === undefined) return false;
    if (!('currentPeriodStart' in value) || value['currentPeriodStart'] === undefined) return false;
    if (!('currentPeriodEnd' in value) || value['currentPeriodEnd'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('isMetered' in value) || value['isMetered'] === undefined) return false;
    if (!('isTrialing' in value) || value['isTrialing'] === undefined) return false;
    if (!('trialEnd' in value) || value['trialEnd'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function SubscriptionFromJSON(json: any): Subscription {
    return SubscriptionFromJSONTyped(json, false);
}

export function SubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subscription {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'displayName': json['display_name'],
        'startDate': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'billingInterval': json['billing_interval'],
        'currentPeriodStart': (new Date(json['current_period_start'])),
        'currentPeriodEnd': (new Date(json['current_period_end'])),
        'cancelAtPeriodEnd': json['cancel_at_period_end'] == null ? undefined : json['cancel_at_period_end'],
        'status': StripeSubscriptionStatusEnumFromJSON(json['status']),
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'items': ((json['items'] as Array<any>).map(SubscriptionItemFromJSON)),
        'isMetered': json['is_metered'],
        'isTrialing': json['is_trialing'],
        'trialEnd': (json['trial_end'] == null ? null : new Date(json['trial_end'])),
        'currency': json['currency'],
    };
}

  export function SubscriptionToJSON(json: any): Subscription {
      return SubscriptionToJSONTyped(json, false);
  }

  export function SubscriptionToJSONTyped(value?: Omit<Subscription, 'currency'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'id': value['id'],
        'display_name': value['displayName'],
        'start_date': value['startDate'] == null ? undefined : ((value['startDate'] as any).toISOString()),
        'billing_interval': value['billingInterval'],
        'current_period_start': ((value['currentPeriodStart']).toISOString()),
        'current_period_end': ((value['currentPeriodEnd']).toISOString()),
        'cancel_at_period_end': value['cancelAtPeriodEnd'],
        'status': StripeSubscriptionStatusEnumToJSON(value['status']),
        'quantity': value['quantity'],
        'items': ((value['items'] as Array<any>).map(SubscriptionItemToJSON)),
        'is_metered': value['isMetered'],
        'is_trialing': value['isTrialing'],
        'trial_end': (value['trialEnd'] == null ? null : (value['trialEnd'] as any).toISOString()),
    };
}
